<template>
  <div>
    <Hero />
    <ServicosSecao />
    <CoberturaSecao />
    <ProcessoSecao />
    <CompromissosSecao />
    <CtaSection />
  </div>
</template>

<script setup>
import Hero from '@/components/Hero.vue'
import ServicosSecao from '@/components/ServicosSecao.vue'
import CoberturaSecao from '@/components/CoberturaSecao.vue'
import ProcessoSecao from '@/components/ProcessoSecao.vue'
import CompromissosSecao from '@/components/CompromissosSecao.vue'
import CtaSection from '@/components/CtaSection.vue'
</script>
